import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import { CHECK_LOGIN, LOGOUT_USER, FORCE_LOGOUT } from './actionTypes';
import { apiError, loginUserSuccessful } from './actions';
import { postLogin } from '../../helpers/auth_helper';
import jwtDecode from 'jwt-decode';

function* loginUser({ payload: { user, history } }) {
        try {
            const response = yield call(postLogin, {
                username: user.userName, 
                password: user.password,
                // accessToken: user.idToken
            });
            
            const { idToken, refreshToken}=response
            console.log("--==response", response, idToken)
            console.log("Refresh Token", refreshToken)
            const decoded = jwtDecode(idToken)
            const {exp}= decoded
            console.log('jwt_decode ::: > ', decoded, exp);
            localStorage.setItem("authUser", JSON.stringify(response));
            localStorage.setItem("Id Token", JSON.stringify(exp));
            localStorage.removeItem('lastActiveRoute')
            yield put(loginUserSuccessful(response));
            history.push('/details');
        } catch (error) {
            yield put(apiError(error));
        }
}

function* logoutUser({ payload: { history } }) {
    try {
        localStorage.removeItem("authUser");
        history.push('/login');
    } catch (error) {
        yield put(apiError(error));
    }
}
function* forceLogout() {
    try {
        localStorage.removeItem("authUser");
    } catch (error) {
        yield put(apiError(error));
    }
}

export function* watchUserLogin() {
    yield takeEvery(CHECK_LOGIN, loginUser)
}

export function* watchUserLogout() {
    yield takeEvery(LOGOUT_USER, logoutUser)
}
export function* watchForceLogout(){
    yield takeEvery(FORCE_LOGOUT, forceLogout)
}
function* loginSaga() {
    yield all([
        fork(watchUserLogin),
        fork(watchUserLogout)
    ]);
    yield all([fork(watchForceLogout)]);
}

export default loginSaga;